import React, { useContext, useEffect, useRef, useState } from 'react';
import Card from '../Card/Card';
import CardContact from '../Card/CardContact';
import CardEditlogin from '../Card/CardEditlogin';
import CardInput from '../Card/CardInput';
import CardProfileGeographic from '../Card/CardProfileGeographic';
import CardSocialmedia from '../Card/CardSocialmedia';
import CardTextArea from '../Card/CardTextArea';
import CardProfilePreview from '../Card/CardProfilePreview';
import axios from 'axios';
import { AuthContext } from '../../context/AuthContext';

export default function CardProfile() {
  const [newPass, setNewPass] = useState();
  const [oldPass, setOldPass] = useState();
  const [confirm, setConfirm] = useState();
  const { user } = useContext(AuthContext);
  const [profileData, setData] = useState({});
  const [areas, setAreas] = useState();
  const nameRef = useRef();
  const [file, setFile] = useState(null);
  const [geographic, setGeographic] = useState();
  const [open, setOpen] = React.useState(false);
  const [provide, setProvide] = useState();
  const [state, setState] = useState({
    // name: nameRef.current?.value,
    username: profileData?.username ? profileData?.username : '',
    name: profileData?.name ? profileData?.name : '',
    first_name: profileData?.first_name ? profileData?.first_name : '',
    surname: profileData?.surname ? profileData?.surname : '',
    email: profileData?.email ? profileData?.email : '',
    phone: profileData?.phone ? profileData?.phone : '',
    geographicareas: profileData?.geographicareas
      ? profileData?.geographicareas
      : '',
    password: profileData?.password ? profileData?.password : '',
    service_online: profileData?.service_online
      ? profileData?.service_online
      : '',
    facebook_handle: profileData?.facebook_handle
      ? profileData?.facebook_handle
      : '',
    twitter_handle: profileData?.twitter_handle
      ? profileData?.twitter_handle
      : '',
    youtube_handle: profileData?.ioutube_handle
      ? profileData?.youtube_handle
      : '',
    picturefile: file ? file : '',
    linkedin_handle: profileData?.iinkedin_handle
      ? profileData?.linkedin_handle
      : '',
    instagram_handle: profileData?.instagram_handle
      ? profileData?.instagram_handle
      : '',
    url: profileData?.url ? profileData?.url : '',
    description: profileData?.description ? profileData?.description : '',
  });
  const [error, setError] = useState(false);
  const saveProfile = async () => {
    /^(?=.*[~`!@#$%^&*()--+={}[\]|\\:;"'<>,.?/_₹]).*$/.test(confirm) &&
      /^(?=.*[0-9]).*$/.test(confirm) &&
      /^\S*$/.test(confirm) &&
      /^(?=.*[A-Z]).*$/.test(confirm) &&
      oldPass === profileData?.password &&
      newPass === confirm &&
      newPass.length > 6 &&
      setOpen(true);
    // : setError(true);

    /^(?=.*[~`!@#$%^&*()--+={}[\]|\\:;"'<>,.?/_₹]).*$/.test(confirm) &&
    /^(?=.*[0-9]).*$/.test(confirm) &&
    /^\S*$/.test(confirm) &&
    /^(?=.*[A-Z]).*$/.test(confirm) &&
    oldPass === profileData?.password &&
    newPass === confirm &&
    newPass.length > 6
      ? await axios({
          method: 'post',
          url: `${process.env.REACT_APP_BASE_URL}/api/updatePartner`,
          headers: { 'Content-Type': 'multipart/form-data' },
          data: state,
        })
          .then(function (response) {
            // console.log(response);
            setOpen(false);
            // console.log(state);
            window.location.reload();
          })
          .catch(function (error) {
            console.log(error);
          })
      : setError(true);
  };
  const saveProfile2 = async () => {
    setOpen(true)(
      await axios({
        method: 'post',
        url: `${process.env.REACT_APP_BASE_URL}/api/updatePartner`,
        headers: { 'Content-Type': 'multipart/form-data' },
        data: state,
      })
        .then(function (response) {
          // console.log(response);
          setOpen(false);
          // console.log(state);
          window.location.reload();
        })
        .catch(function (error) {
          console.log(error);
        })
    );
  };

  const handleClose = () => {
    setOpen(true);
  };
  useEffect(() => {
    const fetchPosts = async () => {
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/getGeographicAreas/${user.success?.partnerId}`
      );
      setAreas(res.data);
    };
    fetchPosts();
  }, [user.success?.partnerId]);
  useEffect(() => {
    const fetchPosts = async () => {
      await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/getOverallSummary/${user.success?.partnerId}`
      );

      // console.log(typeof res.data);
    };
    fetchPosts();
  }, [user.success?.partnerId]);
  // ram@mywellbeingindex.co.uk
  // hello_riddlebox.co.uk
  useEffect(() => {
    const fetchPosts = async () => {
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/getPartnerInformation/${user.success?.partnerId}`
      );
      //   localStorage.setItem(
      //     'profile',res?.data?.name

      // )
      // setLocal(localStorage.getItem('profile'));
      // console.log(local)

      setData(res.data);
      
    };

    fetchPosts();
  }, [user.success?.partnerId]);

  useEffect(() => {
    setState({
      username: profileData?.username ? profileData?.username : '',
      name: profileData?.name ? profileData?.name : '',
      first_name: profileData?.first_name ? profileData?.first_name : '',
      surname: profileData?.surname ? profileData?.surname : '',
      email: profileData?.email ? profileData?.email : '',
      phone: profileData?.phone ? profileData?.phone : '',
      password: profileData?.password ? profileData?.password : '',
      service_online: profileData?.service_online
        ? profileData?.service_online
        : '',
      facebook_handle: profileData?.facebook_handle
        ? profileData?.facebook_handle
        : '',
      twitter_handle: profileData?.twitter_handle
        ? profileData?.twitter_handle
        : '',
      youtube_handle: profileData?.youtube_handle
        ? profileData?.youtube_handle
        : '',
      linkedin_handle: profileData?.linkedin_handle
        ? profileData?.linkedin_handle
        : '',
      instagram_handle: profileData?.instagram_handle
        ? profileData?.instagram_handle
        : '',
      picturefile: file ? file : '',
      geographicareas: profileData?.geographicareas
        ? profileData?.geographicareas
        : '',
      url: profileData?.url ? profileData?.url : '',
      description: profileData?.description ? profileData?.description : '',
    });
  }, [
    file,
    profileData?.description,
    profileData?.email,
    profileData?.facebook_handle,
    profileData?.first_name,
    profileData?.geographicareas,
    profileData?.instagram_handle,
    profileData?.linkedin_handle,
    profileData?.name,
    profileData?.password,
    profileData?.phone,
    profileData?.service_online,
    profileData?.surname,
    profileData?.twitter_handle,
    profileData?.url,
    profileData?.username,
    profileData?.youtube_handle,
  ]);

  function handleChange(evt) {
    const value = evt.target.value;
    setState({
      ...state,
      [evt.target.name]: value,
    });
  }

  useEffect(() => {
    oldPass === profileData?.password &&
      newPass === confirm &&
      newPass > 6 &&
      setState((s) => ({
        ...s,
        password: newPass,
      }));
  }, [confirm, newPass, oldPass, profileData?.password]);

  useEffect(() => {
    setGeographic(
      profileData?.geographicareas
        ? profileData?.geographicareas?.split(',')
        : ''
    );
  }, [profileData?.geographicareas]);
  // useEffect(() => {
  //   console.log(state);
  // }, [state]);

  useEffect(() => {
    setState((s) => ({
      ...s,
      picturefile: file,
    }));
  }, [file]);

  const handleChangelogo = (e) => {
    (e.target.files[0].type?.split('/')[1]?.toLowerCase() === 'jpeg' ||
      e.target.files[0].type?.split('/')[1]?.toLowerCase() === 'png' ||
      e.target.files[0].type?.split('/')[1]?.toLowerCase() === 'jpg') &&
      setFile(e.target.files[0]);
    setState({
      ...state,
      [e.target.name]: file,
    });
    // console.log(state);
  };

  useEffect(() => {
    setProvide(profileData?.service_online);
  }, [profileData]);

  useEffect(() => {
    setState((s) => ({
      ...s,
      service_online: provide,
    }));
  }, [provide]);

  useEffect(() => {
    setState((s) => ({
      ...s,
      geographicareas: geographic?.toString(),
    }));
  }, [geographic]);

  useEffect(() => {}, [profileData]);
  useEffect(() => {
    // console.log(state);
  });
  return (
    <div className="cardsContainer proaaafile">
      <div className="FirstcardsContainer proaaafiles ">
        <Card
          name={profileData?.picturefile}
          handleChange={handleChangelogo}
          file={file}
          setFile={setFile}
          image={`${process.env.REACT_APP_BASE_URL}/` + profileData?.logo}
          title="Wellbeing Score"
        />
        <CardInput
          handleChange={handleChange}
          name={profileData?.name}
          names="name"
          title="Business Name"
          icon="phone"
          nameRef={nameRef}
        />
        <CardInput
          handleChange={handleChange}
          name={profileData?.url}
          names="url"
          title="Web Address"
          icon="global"
        />
      </div>
      <div className="FirstcardsContainer secondCardContainer">
        <div className="descandeditlogin">
          <CardTextArea
            handleChange={handleChange}
            description={profileData?.description}
          />

          <CardContact
            handleChange={handleChange}
            Contactvalues={[
              profileData?.first_name,
              profileData?.surname,
              profileData?.email,
              profileData?.phone,
            ]}
          />
        </div>
        <div className="ContactAndEdit ContactAndEditNew">
          {/* <CardContact
            handleChange={handleChange}
            Contactvalues={[
              profileData?.first_name,
              profileData?.surname,
              profileData?.email,
              profileData?.phone,
            ]}
          /> */}
          <CardSocialmedia
            handleChange={handleChange}
            values={[
              profileData?.facebook_handle,
              profileData?.twitter_handle,
              profileData?.instagram_handle,
              profileData?.youtube_handle,
              profileData?.linkedin_handle,
            ]}
          />
          <CardProfileGeographic
            geographic={geographic}
            setGeographic={setGeographic}
            setAreas={setAreas}
            areas={areas}
            geographicareas={profileData?.geographicareas}
          />
          <CardEditlogin
            saveProfile={saveProfile}
            setOldPass={setOldPass}
            oldPass={oldPass}
            profilePassword={profileData?.password}
            confirm={confirm}
            newPass={newPass}
            error={error}
            setError={setError}
            setConfirm={setConfirm}
            setNewPass={setNewPass}
            handleChange={handleChange}
            LoginData={[profileData?.username, profileData?.password]}
          />
        </div>
      </div>
      <div className="profileSocialAndGeo">
        <div className="socipro"></div>
        <CardProfilePreview
          provide={provide}
          setProvide={setProvide}
          profileData={profileData}
          image={`${process.env.REACT_APP_BASE_URL}/` + profileData?.logo}
          open={open}
          handleClose={handleClose}
          saveProfile2={saveProfile2}
        />
      </div>

      <div
        className="gap"
        style={{ width: '100%', backgroundColor: 'white', height: '60px' }}
      ></div>
    </div>
  );
}
